import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17eadb4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Import Workspace from TX", -1))
const _hoisted_2 = { class: "form-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Destination Folder", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "/" }, "/", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "TX ID", -1))
const _hoisted_8 = { class: "form-input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Data size: ", -1))
const _hoisted_10 = {
  key: 0,
  class: "tx"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "warning" }, "⚠️ Overflow Warning!", -1))
const _hoisted_12 = { class: "modal-footer text-right" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Load Workspace", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "modal-button",
  disabled: ""
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading ...", -1))
const _hoisted_18 = [
  _hoisted_17
]

import { ref, watchEffect } from 'vue';
import { ArweaveWrapper, defaultNetwork } from '@/core/ArweaveWrapper';
import { ArDBWrapper } from '@/core/ArDBWrapper';
import { createToast } from 'mosha-vue-toastify';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import DefaultModal from '@/components/atomic/DefaultModal.vue';
import { JSZipWrapper } from '@/core/JSZipWrapper';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadWorkspaceFromTxDialog',
  props: {
  show: Boolean,
  workspace: Object,
  tx: String,
  txField: String,
  networkParam: String
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;



const showTracker = ref(false);

const txtLoadTXTxField = ref('');
const selLoadTXLocation = ref('');
const loadingContractTX = ref(false);
const defaultSelNetwork = props.networkParam ? props.networkParam : defaultNetwork;
const selNetwork = ref(defaultSelNetwork);
const txDataSize = ref(0);
const loadingMetadata = ref(false);

const closeModal = () => {
  showTracker.value = false;
  emit('close');
};

const initModalFields = async () => {
  // Init fields
  txtLoadTXTxField.value = props.txField;
  selLoadTXLocation.value = '/';
  await loadTxMetadata();
  selNetwork.value = defaultSelNetwork;
};

async function loadTxMetadata() {
  loadingMetadata.value = true;
  try {
    // Load metadata
    const arweaveWrapper = new ArweaveWrapper();
    const ardbWrapper = new ArDBWrapper(arweaveWrapper.arweave);
    const txMetadata = await ardbWrapper.findOneTx(props.txField);
    txDataSize.value = 0;

    if (txMetadata && txMetadata.data && txMetadata.data.size) {
      txDataSize.value = parseInt(txMetadata.data.size);
    }

  } catch (error) {
    createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  loadingMetadata.value = false;
}

watchEffect(() => {
  if (props.show && !showTracker.value) {
    showTracker.value = true;
    initModalFields();
  }
});


const loadFromTXModal = async (tx: string, path: string) => {
  loadingContractTX.value = true;
  try {
    await loadWorkspaceFromParam(tx, path);

  } catch (err) {
    createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  loadingContractTX.value = false;
  closeModal();
};

const loadWorkspaceFromParam = async (workspaceId: string, path: string) => {
  const arweaveWrapper = new ArweaveWrapper();
  const asString = false;
  const file = await arweaveWrapper.getTXData(workspaceId, asString);
  await openWorkspace_helper(file, path);
};


const openWorkspace_helper = (zipFile: File, path: string): Promise<void> => {
  const zip = new JSZipWrapper();
  const method = new Promise<string>((resolve, reject) => {
    zip.openZip(zipFile).then((zFile) => {
      const files = [];

      zFile.forEach(function (relativePath, zipEntry) {
        if (zipEntry.dir) {
          const fullPath = zipEntry.name.slice(0, -1);
          createDirectoryStructureFromPath(fullPath, path);
        } else {
          files.push(zipEntry);
        }
      });

      // Add files
      for (const file of files) {
        const emptyEvent = new Event('emptyEvent');
        const fragments = file.name.split('/');
        const realFName = fragments[fragments.length - 1];
        const rootPath = path.length && path[path.length - 1] !== '/' ?
          `${path}/` : path;
        const tmpPath = rootPath + file.name.substring(0, file.name.length - (realFName.length + 1));
        
        zFile.file(file.name).async("string").then((data) => {
          addEditor(
            emptyEvent,
            false,
            data,
            realFName,
            tmpPath,
            false);
        }).catch((error) => {
          console.error('zipFE:', error);
        })

        
      }
      resolve();
    }).catch((error) => {
      createToast(`${error}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
      reject(error);
    });

  });
  return method;
};

const createDirectoryStructureFromPath = (fullPath: string, basePath: string) => {
  const elements = fullPath.split('/');
  let tmpPath = basePath;

  for (const e of elements) {
    try {
      addFolder(tmpPath, e, true);
      if (e) {
        tmpPath += `/${e}`;
      }
    } catch (err) {
      console.log('dirStructure:', err);
    }
  }
};

const addEditor = (
  event: Event, 
  onlyInParent= false, 
  content='', 
  fileName='', 
  path='/',
  active=true,
  inFileTree=true,
  editorId=-1) => {
  try {
    props.workspace.addEditor(
      event, onlyInParent, content,
      fileName, path, 
      active, inFileTree, editorId);
  } catch (err) {
    createToast(`editor: ${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  // emit('workspace-change', editors);
};


const addFolder =  (path: string, folderName: string, debugInConsole=false) => {
  try {
    props.workspace.addFolder(path, folderName, debugInConsole);
  } catch (err) {
    if (debugInConsole) {
      console.error('addFolder', err);
    } else {
      createToast(`folder: ${err}`,
        {
          type: 'danger',
          showIcon: true,
          position: 'bottom-right',
        });
    }
  }
};
function byte2kb(bytes: number) {
  return (bytes / 1024).toFixed(4);
}

function kb2mb(kb: number) {
  return (kb / 1024).toFixed(4);
}

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createBlock(DefaultModal, { key: 0 }, {
        header: _withCtx(() => [
          _createElementVNode("h3", null, [
            _createVNode(_unref(DefaultIcon), {
              class: "title-icon",
              icon: "codicon-mirror"
            }),
            _hoisted_1
          ])
        ]),
        body: _withCtx(() => [
          (!loadingContractTX.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selLoadTXLocation).value = $event))
                  }, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreePaths(), (path) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                        path
                          ? (_openBlock(), _createElementBlock("option", {
                              key: 0,
                              value: path
                            }, _toDisplayString(path), 9, _hoisted_5))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 512), [
                    [
                      _vModelSelect,
                      selLoadTXLocation.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((txtLoadTXTxField).value = $event)),
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (txtLoadTXTxField.value != '' ? loadFromTXModal(txtLoadTXTxField.value, selLoadTXLocation.value) : false), ["enter"])),
                    type: "text"
                  }, null, 544), [
                    [
                      _vModelText,
                      txtLoadTXTxField.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", null, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(txDataSize.value) + " bytes / " + _toDisplayString(byte2kb(txDataSize.value)) + " kb / " + _toDisplayString(kb2mb(byte2kb(txDataSize.value))) + " mb ", 1)
                  ])
                ]),
                (txDataSize.value && kb2mb(byte2kb(txDataSize.value)) >= 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(" Data size is too big. ")
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (loadingContractTX.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Loading ... Please hold on! ")
              ], 64))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            (!loadingContractTX.value && !loadingMetadata.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["modal-button", { 'modal-button-primary': txtLoadTXTxField.value }]),
                  disabled: !txtLoadTXTxField.value,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (loadFromTXModal(txtLoadTXTxField.value, selLoadTXLocation.value)))
                }, _hoisted_15, 10, _hoisted_13))
              : _createCommentVNode("", true),
            (loadingContractTX.value || loadingMetadata.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "modal-button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (closeModal()))
            }, " Close ")
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})